'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var DirFlat = require('./dir-flat');

var flatToShard = require('./flat-to-shard');

var Dir = require('./dir');

var toPathComponents = require('./utils/to-path-components');

var errCode = require('err-code');

var first = require('it-first');

function addToTree(_x4, _x5, _x6) {
  return _addToTree.apply(this, arguments);
}

function _addToTree() {
  _addToTree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(elem, tree, options) {
    var pathElems, lastIndex, parent, currentPath, i, pathElem, last, dir;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            pathElems = toPathComponents(elem.path || '');
            lastIndex = pathElems.length - 1;
            parent = tree;
            currentPath = '';
            i = 0;

          case 5:
            if (!(i < pathElems.length)) {
              _context2.next = 30;
              break;
            }

            pathElem = pathElems[i];
            currentPath += "".concat(currentPath ? '/' : '').concat(pathElem);
            last = i === lastIndex;
            parent.dirty = true;
            parent.cid = null;
            parent.size = null;

            if (!last) {
              _context2.next = 20;
              break;
            }

            _context2.next = 15;
            return parent.put(pathElem, elem);

          case 15:
            _context2.next = 17;
            return flatToShard(null, parent, options.shardSplitThreshold, options);

          case 17:
            tree = _context2.sent;
            _context2.next = 27;
            break;

          case 20:
            _context2.next = 22;
            return parent.get(pathElem);

          case 22:
            dir = _context2.sent;

            if (!dir || !(dir instanceof Dir)) {
              dir = new DirFlat({
                dir: true,
                parent: parent,
                parentKey: pathElem,
                path: currentPath,
                dirty: true,
                flat: true,
                mtime: dir && dir.unixfs && dir.unixfs.mtime,
                mode: dir && dir.unixfs && dir.unixfs.mode
              }, options);
            }

            _context2.next = 26;
            return parent.put(pathElem, dir);

          case 26:
            parent = dir;

          case 27:
            i++;
            _context2.next = 5;
            break;

          case 30:
            return _context2.abrupt("return", tree);

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _addToTree.apply(this, arguments);
}

function treeBuilder(_x, _x2, _x3) {
  return _treeBuilder.apply(this, arguments);
}

function _treeBuilder() {
  _treeBuilder = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, block, options) {
    var tree, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, unwrapped;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tree = new DirFlat({
              root: true,
              dir: true,
              path: '',
              dirty: true,
              flat: true
            }, options);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 3;
            _iterator = _asyncIterator(source);

          case 5:
            _context.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 11;
            return _awaitAsyncGenerator(_step.value);

          case 11:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 25;
              break;
            }

            entry = _value;

            if (entry) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("continue", 22);

          case 16:
            _context.next = 18;
            return _awaitAsyncGenerator(addToTree(entry, tree, options));

          case 18:
            tree = _context.sent;

            if (!(!entry.unixfs || !entry.unixfs.isDirectory())) {
              _context.next = 22;
              break;
            }

            _context.next = 22;
            return entry;

          case 22:
            _iteratorNormalCompletion = true;
            _context.next = 5;
            break;

          case 25:
            _context.next = 31;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 31:
            _context.prev = 31;
            _context.prev = 32;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 36;
              break;
            }

            _context.next = 36;
            return _awaitAsyncGenerator(_iterator.return());

          case 36:
            _context.prev = 36;

            if (!_didIteratorError) {
              _context.next = 39;
              break;
            }

            throw _iteratorError;

          case 39:
            return _context.finish(36);

          case 40:
            return _context.finish(31);

          case 41:
            if (options.wrapWithDirectory) {
              _context.next = 50;
              break;
            }

            if (!(tree.childCount() > 1)) {
              _context.next = 44;
              break;
            }

            throw errCode(new Error('detected more than one root'), 'ERR_MORE_THAN_ONE_ROOT');

          case 44:
            _context.next = 46;
            return _awaitAsyncGenerator(first(tree.eachChildSeries()));

          case 46:
            unwrapped = _context.sent;

            if (unwrapped) {
              _context.next = 49;
              break;
            }

            return _context.abrupt("return");

          case 49:
            tree = unwrapped.child;

          case 50:
            if (tree instanceof Dir) {
              _context.next = 55;
              break;
            }

            if (!(tree && tree.unixfs && tree.unixfs.isDirectory())) {
              _context.next = 54;
              break;
            }

            _context.next = 54;
            return tree;

          case 54:
            return _context.abrupt("return");

          case 55:
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(tree.flush(tree.path, block)), _awaitAsyncGenerator), "t1", 56);

          case 56:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _treeBuilder.apply(this, arguments);
}

module.exports = treeBuilder;